// libs
import React from 'react';
import AuthService from "../../../../../services/AuthService";

// components
import { Link } from 'react-router-dom';

const MemberAlerts = (props) => {
    const { member, toApiLogs } = props;
    if (!member) {
        return null; 
    }

    const output = [];

    if (member.isPending) {
        output.push(
            <div className="alert alert--outline alert--success margin--40--top" key="2">
                {/* {<span>This is a new member application and is not yet available in the POS system.</span>} */}
                {<span>This new account is currently being setup...</span>}
            </div>
        );
    }

    if (member.isPendingUpdate && !member.isManuallyCompleted) {
        output.push(
            <div className="alert alert--outline alert--success margin--40--top" key="3">
                { !AuthService.isAdmin() && <span>This member was recently updated and we are still currently processing the request. The updated details are populated below.</span>}
                 { AuthService.isAdmin() && <span>This member was recently updated and we are currently still processing the request. The updated details are populated below.</span>}
            
            </div>
        );
    }  
    
    if (member.updateDidFail || member.createDidFail) {
        {AuthService.isAdmin() && 
            output.push(
                <div className="alert alert--outline alert--error margin--40--top" key="3">
                {/* <span>The create/update member process failed at <b>{member.failed_on}</b> step . Please check the logs to fix the issue.</span> */}
                {/* <span>The API is down at <b>{member.failed_on}</b>. Please check the logs to fix the issue.</span> */}
                <span onClick={toApiLogs} style={{ cursor: 'pointer' }}>Issues with <b>{member.failed_on}</b> API. Please check the logs to fix the issue or click here.</span>
                </div>
            );
        }
    }

    if (!member.isPending && !member.isActiveRecord) {
        if (member.history && member.history.length > 0) {
            const link = <Link to={'/members/' + member.givexCustomerId}>current card number</Link>;
            output.push(
                <div className="alert alert--outline alert--warning margin--40--top" key="1">
                <span>
                    You are viewing an old card number and should not use this record. View the member's {link}.
                </span>
                </div>
            );
        }
        else {
            output.push(
                <div className="alert alert--outline alert--warning margin--40--top" key="1">
                <span>
                    You are viewing a deleted card and should not use this record.
                </span>
                </div>
            );
        }
    }

    return output;
};

export default MemberAlerts;
